(() => {
  const form = document.getElementById('ContactForm');
  if (!form) return;
  const params = new URLSearchParams(location.search);
  const plate = params.get('plate');
  const wheel = params.get('wheel');
  const part = params.get('part');
  const partNeedsCar = Boolean(part) && params.get('needs_car') === '1';
  const fit = params.get('fit') === '1';
  const style = (plate || wheel || part || (fit ? 'Vehicle fit check' : '')).slice(0, 180);
  const car = document.getElementById('ContactCar');
  if (car && !car.value.trim()) car.value = (params.get('car') || '').slice(0, 160);
  const topic = document.getElementById('ContactTopic');
  const destination = document.getElementById('ContactDestination');
  const updateFields = () => {
    const value = topic ? topic.value : '';
    const isPlate = /plate setup/i.test(value);
    const needsCar = isPlate || /steering wheel|fit my car/i.test(value) || partNeedsCar;
    if (car) {
      car.required = needsCar;
      const label = document.querySelector('label[for="ContactCar"]');
      if (label) label.textContent = 'Your car: year, make, model and trim' + (needsCar ? ' (required)' : ' (optional)');
    }
    const order = document.getElementById('ContactOrder');
    if (order) order.closest('.pdp__field').hidden = needsCar || Boolean(style);
    if (destination) {
      destination.closest('.pdp__field').hidden = !isPlate;
      destination.required = isPlate;
      destination.disabled = !isPlate;
    }
  };
  if (topic) topic.addEventListener('change', updateFields);
  if (car) car.addEventListener('input', () => car.setCustomValidity(''));
  form.addEventListener('submit', event => {
    if (car && car.required && !/\b(?:19|20)\d{2}\b/.test(car.value)) {
      event.preventDefault();
      car.setCustomValidity('Include your car’s year, make and model, for example 2020 BMW 330i.');
      car.reportValidity();
    }
  });
  updateFields();
  if (!style) return;
  const back = document.querySelector('[data-contact-back]');
  const from = params.get('from') || '';
  if (back) {
    back.hidden = false;
    if (/^\/pages\/catalog-inquiries#[a-z0-9-]+$/.test(from)) back.href = from;
  }
  const title = document.querySelector('.contact .page__title');
  if (title) title.textContent = plate ? 'Check your plate setup' : wheel ? 'Get a wheel quote' : part ? (partNeedsCar ? 'Check fit and price' : 'Ask about this item') : 'Let’s check the fit.';
  const order = document.getElementById('ContactOrder');
  if (order) order.closest('.pdp__field').hidden = true;
  if (car) car.required = !part || partNeedsCar;
  const message = document.getElementById('ContactMessage');
  if (topic) {
    if (part && !plate && !wheel && !Array.from(topic.options).some(option => /parts and car care inquiry/i.test(option.text))) {
      const option = document.createElement('option');
      option.value = 'Parts and car care inquiry';
      option.textContent = 'Parts and car care inquiry';
      topic.appendChild(option);
    }
    const match = Array.from(topic.options).find(option => plate ? /plate setup/i.test(option.text) : wheel ? /steering wheel/i.test(option.text) : part ? /parts and car care inquiry/i.test(option.text) : /fit my car/i.test(option.text));
    if (match) topic.value = match.value;
    topic.closest('.pdp__field').hidden = true;
  }
  if (plate) {
    if (destination) { destination.closest('.pdp__field').hidden = false; destination.required = true; }
    const intro = document.querySelector('.contact__intro');
    if (intro) intro.textContent = 'Tell us your car and location. We will confirm availability, fit, included parts, price and delivery before an order.';
    const submit = document.querySelector('#ContactForm button[type="submit"]');
    if (submit) submit.textContent = 'Request availability';
  }
  updateFields();
  const context = document.querySelector('[data-contact-context]');
  if (context) {
    context.hidden = false;
    context.querySelector('strong').textContent = style;
    context.querySelector('p').textContent = part && !partNeedsCar ? 'We confirm the exact item, price and delivery by email. This is an inquiry, not an order. No payment is taken here.' : 'We confirm fit, included parts, price and delivery by email. This is an inquiry, not an order. No payment is taken here.';
  }
  if (!plate) {
    const intro = document.querySelector('.contact__intro');
    if (intro) intro.textContent = part ? (partNeedsCar ? 'Tell us about your car and where the part will be installed. We’ll reply by email with the next step.' : 'Tell us what you need. We’ll reply by email with the next step.') : 'Tell us about your car. We’ll reply by email with the next step.';
    const submit = form.querySelector('button[type="submit"]');
    if (submit) submit.textContent = wheel ? 'Request my quote' : part ? 'Send item inquiry' : 'Send fit check';
  }
  if (message && !message.value.trim()) message.value = plate
    ? 'I am interested in: ' + style + '.\n\nPlate size: \nIntended display use: \n\nPlease confirm availability for my location, vehicle fit, included parts, total price and delivery time.'
    : wheel ? 'I would like a quote for: ' + style + '.\n\nPlease confirm fit, included parts, available finishes, total price and delivery time for my car.'
    : part ? 'I am interested in: ' + style + '.\n\n' + (partNeedsCar ? 'Installation location: ' + (params.get('install') || '').slice(0, 120) + '\nMeasurements or fit details: ' + (params.get('dimensions') || '').slice(0, 240) + '\n\nPlease confirm fit, exact item, included parts, total price and delivery time for my car.' : 'Please confirm the exact item, total price and delivery time.')
    : 'Please help me choose the right part for my car.\n\nProduct I am interested in: ';
})();
